import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import {
  ActionSaveType,
  AutomationRuleActionsEnum,
} from 'src/editor/shared/types/automation-rules/actions-types'
import { CourseAccessTypeEnum } from 'src/editor/shared/types/course'
import {
  OptionSingleValueType,
  OptionType,
} from 'src/editor/shared/ui-lib/select-new/select-new'

export const updateAction = ({
  action,
  option,
  value,
  accessType,
}: {
  action: ActionSaveType
  option?: OptionSingleValueType<PageLocaleEnum | number>
  value?: string
  accessType?: CourseAccessTypeEnum
}) => {
  switch (action.type) {
    case AutomationRuleActionsEnum.add_tag:
    case AutomationRuleActionsEnum.remove_tag: {
      if (option) {
        const castedOption = option as OptionType<number>
        return {
          ...action,
          tag: {
            id: castedOption.value,
            name: castedOption.label,
          },
        }
      }
      break
    }
    case AutomationRuleActionsEnum.revoke_access_to_course:
    case AutomationRuleActionsEnum.enroll_in_course: {
      const castedOption = option as OptionType<number>
      return {
        ...action,
        course: castedOption
          ? {
              id: castedOption.value,
              name: castedOption.label,
            }
          : action.course,
        courseAccessType: accessType || action.courseAccessType,
      }
    }
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
    case AutomationRuleActionsEnum.enroll_in_course_bundle: {
      const castedOption = option as OptionType<number>
      return {
        ...action,
        courseBundle: castedOption
          ? {
              id: castedOption.value,
              name: castedOption.label,
            }
          : action.courseBundle,
        enrollmentAccessType: accessType || action.enrollmentAccessType,
      }
    }
    case AutomationRuleActionsEnum.send_email: {
      if (option) {
        const castedOption = option as OptionType<number>
        return {
          ...action,
          systemeEmail: {
            id: castedOption.value,
            subject: castedOption.label,
          },
        }
      }
      break
    }
    case AutomationRuleActionsEnum.send_email_to_specific_address: {
      if (option) {
        const castedOption = option as OptionType<number>
        return {
          ...action,
          emailMessageWithRecipient: {
            id: castedOption.value,
            mailing: {
              currentEmail: {
                subject: castedOption.label,
              },
            },
          },
        }
      }
      break
    }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
    case AutomationRuleActionsEnum.unsubscribe_from_campaign: {
      if (option) {
        const castedOption = option as OptionType<number>
        return {
          ...action,
          campaign: {
            id: castedOption.value,
            name: castedOption.label,
          },
        }
      }
      break
    }
    case AutomationRuleActionsEnum.send_webhook: {
      return {
        ...action,
        webhookUrl: value,
      }
    }
    case AutomationRuleActionsEnum.revoke_access_to_community:
    case AutomationRuleActionsEnum.grant_access_to_community: {
      if (option) {
        const castedOption = option as OptionType<number>
        return {
          ...action,
          community: {
            id: castedOption.value,
            name: castedOption.label,
          },
        }
      }
      break
    }
    case AutomationRuleActionsEnum.create_user: {
      if (option) {
        const castedOption = option as OptionType<PageLocaleEnum>
        return {
          ...action,
          locale: castedOption.value,
        }
      }
      break
    }
  }
  return action
}
